// extracted by mini-css-extract-plugin
export var blue = "_3h-f";
export var brand = "_3h-b";
export var darkGrey = "_3h-e";
export var disabled = "_3h-4";
export var disabledSubtle = "_3h-5";
export var error = "_3h-6";
export var green = "_3h-g";
export var grey = "_3h-d";
export var icon = "_3h-0";
export var inherit = "_3h-a";
export var lightGrey = "_3h-c";
export var orange = "_3h-i";
export var pink = "_3h-k";
export var primary = "_3h-1";
export var purple = "_3h-l";
export var red = "_3h-j";
export var secondary = "_3h-2";
export var success = "_3h-9";
export var tertiary = "_3h-3";
export var warning = "_3h-7";
export var warningSecondary = "_3h-8";
export var white = "_3h-m";
export var yellow = "_3h-h";